import { track } from "./MetricsProvider";
import "../../../Engine/vendor/click-listener.js"; // https://git.skbkontur.ru/ke/click-listener

declare global {
    interface Window {
        listenToClicks?: (
            callback: (trackData: {
                own_class: string;
                own_tid: string;
                id: string;
                class: string;
                tid: string;
                text: string;
            }) => void
        ) => void;
    }
}

if (typeof window !== "undefined" && window.listenToClicks) {
    window.listenToClicks(function (trackData) {
        track("candy-auto", trackData.tid || "NO_TID", trackData);
    });
}
